import { decodeDisplayText } from './displayText';
import { normalizeMarkdownForStorage } from './markdownTheme';

export const URL_PREVIEW_TITLE_COLLAPSE_LIMIT = 270;
export const URL_PREVIEW_DESCRIPTION_COLLAPSE_LIMIT = 360;

const URL_PREVIEW_MARKDOWN_FORMATTING_PATTERN = /(?:^|\n)\s{0,3}(?:#{1,6}\s|>\s|[-*+]\s|\d+\.\s)|(?:^|\n)\s*[-*+]\s+\[(?: |x|X)\]\s+|\[[^\]]+\]\([^)]+\)|```|`[^`\n]+`|\+\+[^+\n].*?\+\+|==[^=\n].*?==|(?:^|[^\w])(?:\*\*|__)[^*_]+(?:\*\*|__)|(?:^|[^\w])(?:\*|_)[^*_\n]+(?:\*|_)/m;

const URL_PREVIEW_ENTITY_REPLACERS = [
    [/&nbsp;|&#160;/gi, '\u00a0'],
    [/&gt;|&#62;/gi, '>'],
    [/&lt;|&#60;/gi, '<'],
    [/&quot;|&#34;/gi, '"'],
    [/&#39;|&apos;/gi, '\''],
    [/&amp;|&#38;/gi, '&']
];

export const hasUrlPreviewMarkdownFormatting = (text = '') =>
    typeof text === 'string' && URL_PREVIEW_MARKDOWN_FORMATTING_PATTERN.test(text);

export const normalizeUrlPreviewText = (value = '') => {
    if (typeof value !== 'string' || value.length === 0) {
        return '';
    }

    let normalizedValue = hasUrlPreviewMarkdownFormatting(value) ? value : decodeDisplayText(value);

    for (let pass = 0; pass < 2; pass += 1) {
        const decodedValue = URL_PREVIEW_ENTITY_REPLACERS.reduce(
            (currentValue, [pattern, replacement]) => currentValue.replace(pattern, replacement),
            normalizedValue
        );

        if (decodedValue === normalizedValue) {
            break;
        }

        normalizedValue = decodedValue;
    }

    return normalizeMarkdownForStorage(normalizedValue).trim();
};

export const truncateUrlPreviewText = (
    value = '',
    maxChars = URL_PREVIEW_TITLE_COLLAPSE_LIMIT
) => {
    if (typeof value !== 'string') {
        return '';
    }

    const normalizedValue = value.trim();
    if (normalizedValue.length <= maxChars) {
        return normalizedValue;
    }

    const softSlice = normalizedValue.slice(0, maxChars);
    const lastWhitespaceIndex = Math.max(
        softSlice.lastIndexOf(' '),
        softSlice.lastIndexOf('\n')
    );
    const cutoff = lastWhitespaceIndex >= Math.floor(maxChars * 0.7)
        ? lastWhitespaceIndex
        : maxChars;

    return `${softSlice.slice(0, cutoff).trimEnd()}…`;
};
